<div class="kng-card-list" role="grid" attr.aria-label="Card list component. Contains {{ dataList.length }} items"
  #cardListTable>
  <div role="row" aria-label="Card list header" class="row header-row" [ngClass]="{
      'header-accordion-table':
        state.view === View.accordionDeskTop ||
        state.view === View.accordionMobile
    }" *ngIf="headerList">

    <div role="cell" *ngIf="isCheckBoxRequired" tabindex="0" attr.aria-label="header for checkbox column"class="col checkbox" [ngClass]="{'p-0': state.view === View.tableDesktop}">
      <div class="d-flex" [ngClass]="{'variable-width':(state.view === View.tableMobile || state.view === View.tableDesktop) }">
        <mat-checkbox tabindex="0" [checked]="checkboxState"
            (change)="handleHeaderCheckboxChange($event.checked)">
        </mat-checkbox>
      </div>
    </div>

    <div role="cell" tabindex="0" attr.aria-label="header for '{{ header?.label }}' column"
      *ngFor="let header of headerList; let headerIndex = index" class="col" [ngClass]="{
        'header-icon':
          header?.category === FieldType.action ||
          header?.category === FieldType.indicator,
        'p-0': state.view === View.tableDesktop,
        'telematics-icon': header?.category === FieldType.image
      }">
      <div class="d-flex" [ngClass]="{
          'header-wrapper-class':
            header?.category === FieldType.primaryText ||
            header?.category === FieldType.link || header?.category === FieldType.text,
          'variable-width':
            (state.view === View.tableMobile ||
              state.view === View.tableDesktop) &&
            header?.category !== FieldType.primaryText &&
            header?.category !== FieldType.link
        }">
        <div class="header-label" *ngIf="
            header?.category !== FieldType.action &&
            header?.category !== FieldType.indicator
          ">
          {{ header?.label }}
        </div>
        <div *ngIf="
            header?.category === FieldType.indicator
          ">
          <span class="non-breaking-space">&#160;</span>
        </div>
        <div class="sort-icon" role="button" tabindex="0" (keyup)="sortColumnByKey($event, header,headerIndex)"
          [attr.aria-label]="sortingtext" *ngIf="
            header?.category !== FieldType.action &&
            header?.category !== FieldType.indicator && !state.hideSort && !header?.hideSort
          " [ngStyle]="{
            transform:
              (header?.sortOrder === 'desc' && !isRaymond) ? 'rotate(180deg)' : 'rotate(0deg)', 'transform-origin': '9px'
          }" [ngClass]="{ activeSortIcon: state.activeIndex === headerIndex ,
               activeSortdownIcon: header?.sortOrder === 'desc' && isRaymond &&  state.activeIndex === headerIndex 
          }"
          (click)="sortColumn(header, headerIndex)">
        </div>
        <div *ngIf="header?.isTooltipPresent=== true" tabindex="0" class="card-list-tooltip-desktop">
          <img matTooltipPosition="below" matTooltip={{header.tooltip?.content}} class="info-image--desktop-view" (window:scroll)="tooltipheader.hide()"
            #tooltipheader="matTooltip" attr.aria-label="{{ header.tooltip?.content }}" alt="info icon"
            src="assets/card_list_tooltip_desktop.svg"
            (mouseenter)="modifyTooltipContent()"
            matTooltipClass="{{header.tooltipClass? header.tooltipClass : 'card-list-tooltip'}} preventOverlap"
            matTooltipPositionAtOrigin="true">
        </div>
      </div>
    </div>
  </div>
  <div role="rowgroup" aria-label="Card list content" class="accordion" id="accordionPanelsStayOpenExample" *ngIf="
      (state.view === View.accordionDeskTop ||
      state.view === View.accordionMobile ||
      state.view === View.tableMobile)
    ">
    <div *ngIf="state.error && dataList.length === 0 && !state.loading" class="no-results">
      <img src="{{ state.error?.icon }}" alt="noresults" />
      <div class="no-results-text">{{ state.error?.message }}</div>
      <div class="no-results-subtext">{{ state.error?.messageSubText }}</div>
    </div>
    <div *ngIf="dataList && dataList.length > 0">
      <div role="row" tabindex="0" class="accordion-item"
        *ngFor="let category of dataList| paginate: { itemsPerPage: 50,currentPage: pageNumber,totalItems: pager.totalItems }; let listIndex = index"
        attr.aria-label="Card list item #{{ listIndex + 1 }} ">
        <div class="row  accordion-header header-label-row m-0 p-0">

          <button *ngIf="!state.loading" role="button" tabindex="0" class="accordion-button d-flex" type="button"
            [ngClass]="{
                collapsed: category.collapsed,
                'accordion-button-table': state.view === View.tableMobile
              }" data-bs-toggle="collapse" [attr.data-target]="'#collapse' + listIndex"
            [attr.aria-expanded]="category.collapsed" [attr.aria-controls]="category.collapsed"
            (click)="openCollapseAccordion(listIndex)"></button>
            
            <div *ngIf="isCheckBoxRequired" role="cell" tabindex="0" attr.aria-label="Card list item #0, value: Checkbox" class="col header-label-value checkbox deskView">
            <div role="cell"  class=" col header-label-value" tabindex="0" attr.aria-label="header for checkbox column">
              <mat-checkbox [checked]="category.checked"
                (change)="handleItemCheckBoxChange(category, $event.checked, listIndex)
                " [disabled]="category.changeRequest?.display === 'disable' " 
                matTooltipPosition="right"
                [matTooltip]="category.changeRequest?.tooltip || ''"
                attr.aria-label="{{ category.changeRequest?.tooltip }}" matTooltipClass="bulkTooltip telematicsStatusTooltip" 
                >
              </mat-checkbox>
            </div>
            </div>

          <div role="cell" tabindex="0" attr.aria-label="Card list item #{{ listIndex + 1 }}, value: {{
              value?.labelValue
            }}" *ngFor="let value of category.values | slice: 0:headerList.length" class="col header-label-value"
            [ngClass]="{
                'mob-indicator-icon': value?.category === FieldType.indicator,
                'hide-cell': (value.category === FieldType.text && value.label === 'telematicsStatus' && isRaymond) 
              }">
            <div *ngIf="state.loading" class="gradient-loader"></div>
            <div *ngIf="!state.loading">
              <div class="{{value.category}}" [ngClass]="{
                'asset-wrapper-class':
                  value?.category === FieldType.primaryText
              }" *ngIf="value.category === FieldType.text ?  (value.category === FieldType.text && value.label !== 'telematicsStatus') : checkValueCategory(value.category)">
              <div *ngIf="value.category === FieldType.invoice" class="invoice-status-indicator" [ngClass]="{
                  'past-due': value.labelValue === InvoiceStatus.pastDue,
                  open: value.labelValue === InvoiceStatus.open,
                  upcoming: value.labelValue === InvoiceStatus.upcoming,
                  paid: value.labelValue === InvoiceStatus.paid,
                  none: value?.labelValue === '' || value?.labelValue === '—'
                }"></div>
                <span *ngIf="value.displayType; else regularText" [innerHTML]="useDisplayType(value)" matTooltipPosition="right" matTooltip="{{ removeTooltipSeparator(value.labelValue) }}"
                matTooltipClass="address-tooltip" attr.aria-label="{{ value.labelValue }}"
                #tooltip="matTooltip"></span>
                    <ng-template #regularText>{{ (value?.labelValue !== "" && value?.labelValue !== null) ? value?.labelValue : "—" }}</ng-template>
              </div>
              <div *ngIf="value.category === FieldType.currency"
                attr.aria-label="{{ value?.labelValue || 'undefined' }}" tabindex="0">
                {{
                (value?.labelValue === "0.00") ? "$0" :
                value?.labelValue !== "—" && value?.labelValue !== ""
                ? (convertStringToNumber(value?.labelValue)
                | currency: value?.currency:"symbol":"1.2-2") : "—"
                }}
              </div>
              <div *ngIf="value.category === FieldType.date" attr.aria-label="{{ value?.labelValue ? (convertStringToNumber(value?.labelValue)
                | date: 'MM/dd/YYYY') || 'undefined' : 'undefined' }}" tabindex="0">
                {{
                value?.labelValue !== "—" && value?.labelValue !== "" && value?.labelValue !== null
                ? (convertStringToNumber(value?.labelValue)
                | date: "MM/dd/YYYY") : "—"
                }}

              </div>
              <div attr.aria-label="{{ value?.labelValue || 'undefined' }}" tabindex="0" *ngIf="
                value.category === FieldType.primaryText ||
                        value.category === FieldType.myQuoteStatus || value.category === FieldType.equipmentAddress || value.category === FieldType.primarySubLocation

              ">
                <div *ngIf="state.loading" class="gradient-loader"></div>
                <div *ngIf="!state.loading">
                  <div *ngIf="value.category === FieldType.myQuoteStatus" class="myQuote-status-indicator" [ngClass]="{
                'quoteinProcess': value.labelValue === myQuoteStatus.quoteinProcess,
                'quoteAccepted': value.labelValue === myQuoteStatus.quoteAccepted,
                'ordered': value.labelValue === myQuoteStatus.ordered,
                'expired': value.labelValue === myQuoteStatus.expired,
                'readyForReview': value.labelValue === myQuoteStatus.readyForReview,
                'none': value?.labelValue === '' || value?.labelValue === '—'
              }"></div>{{ value?.labelValue !== "" ? value?.labelValue : "—" }}
                </div>
              </div>
              <div *ngIf="value.category === FieldType.dateString" attr.aria-label="{{ value?.labelValue !== '—' && value?.labelValue !== '' && value?.labelValue !== null ? (convertStringToDate(value?.labelValue)
                | date: 'MM/dd/yyyy') || 'undefined' : 'undefined' }}" tabindex="0">
                {{
                value?.labelValue !== "—" && value?.labelValue !== "" && value?.labelValue !== null
                ? (convertStringToDate(value?.labelValue)
                | date: "MM/dd/yyyy") : "—"
                }}

              </div>
              <div [ngClass]="{'invoice-number':value?.label === invoiceCheck.invoice}"
                *ngIf="value.category === FieldType.link">
                <button class="label-link vin-wrapper-class" [ngClass]="{
                    'blank-link':
                      value?.labelValue === '—' || value?.labelValue === ''|| value?.labelValue === null
                  }" attr.aria-label="{{ value?.labelValue || 'undefined' }}"
                  (click)="value.label === invoiceCheck.invoice? downloadInvoicePDF(value.labelValue):linkToRedirectionEquipment(value.labelValue, value.label, category?.id,category?.customerId,category?.orderId,category?.locationId )"
                  tabindex="0">
                  {{ value?.labelValue? value?.labelValue : "—" }}</button>
                <span><img *ngIf="value.label === invoiceCheck.invoice && !isRaymond" class="pdfIcon" src="/assets/myservice_pdf.svg"
                    tabindex="0" aria-label="Download pdf Icon" alt="Download pdf Icon"
                    (click)="downloadInvoicePDF(value.labelValue)" /></span>
              </div>
              <div *ngIf="value.category === FieldType.pdf">
                <div *ngIf="!category?.documentURL">
                  <div class="labelPdf-link vin-wrapper-class" [ngClass]="{
                          'blank-link': value?.labelValue === '—' || value?.labelValue === '' || value?.labelValue === null || !category?.documentURL
                        }" attr.aria-label="{{ value?.labelValue || 'undefined' }}" tabindex="0">
                    {{ value?.labelValue ? value?.labelValue : '—' }}
                  </div>
                </div>
                <div *ngIf="category?.documentURL" class="pdf-available vin-wrapper-class">
                  <button class="labelPdf-link" attr.aria-label="{{ value?.labelValue || 'undefined' }}" tabindex="0"
                    (click)="linktoDownloadPDF(
                      value.labelValue,
                      value.label,
                      category?.documentURL
                    )">
                    {{ value?.labelValue ? value?.labelValue : '—' }}
                  </button>
                  <div><img class="pdfImage" src="assets/pdf.svg" tabindex="0" aria-label="Download pdf Icon"
                      alt="Download pdf Icon"
                      (click)="linktoDownloadPDF(value.labelValue,value.label,category?.documentURL)" />
                  </div>
                </div>
              </div>
              <div attr.aria-label="{{ value?.labelValue || 'undefined' }}" tabindex="0" [ngClass]="{
                'asset-wrapper-class':
                  value?.category === FieldType.crStatus
              }" *ngIf="
                value.category === FieldType.primaryText ||
                        value.category === FieldType.crStatus
              ">
                <div *ngIf="state.loading" class="gradient-loader"></div>
                <div *ngIf="!state.loading">
                  <div *ngIf="value.category === FieldType.crStatus" class="cr-status-indicator" [ngClass]="{
                'awaitingApproval': value.labelValue === crStatus.awaitingApproval,
                'approved': value.labelValue === crStatus.approved,
                'cancelled': value.labelValue === crStatus.cancelled,
                'none': value?.labelValue === '' || value?.labelValue === '—'
              }"></div>{{ value?.labelValue !== "" ? value?.labelValue : "—" }}
                </div>
              </div>

              <div *ngIf="value.category === FieldType.indicator && value?.label !== FieldType.telematicsStatus"
                [ngClass]="{
                  'mob-indicator-icon': value?.category === FieldType.indicator
                }" attr.aria-label="{{ value?.labelValue || 'undefined' }}">
                <div [hidden]="!value.labelValue" tabindex="0">
                  <img src="{{ value?.icon }}" alt="{{ state?.serviceCampaignAltText }}"
                    [matTooltipPosition]="position.value!" matTooltip="{{ state?.tooltipMessage }}"
                    matTooltipClass="serviceTooltip" aria-label="Button that displays a tooltip in various positions"
                    #tooltip="matTooltip" (click)="tooltip.toggle()" />
                </div>
              </div>
              <div tabindex="0" attr.aria-label="{{ value?.labelValue || 'undefined' }}" [ngClass]="{
                'mob-indicator-icon': value?.category === FieldType.indicator
              }" *ngIf="value?.category === FieldType.indicator && value?.label === FieldType.telematicsStatus">
                <div *ngIf="state.loading" class="gradient-loader"></div>
                <div *ngIf="!state.loading && (value?.labelValue === 'connected'|| value?.labelValue === 'Active')" tabindex="0">
                  <img id="tooltip-{{FieldType.telematicsStatus}}-{{listIndex}}" matTooltipPosition="right"
                    src="{{ value?.icon }}" alt="{{ value?.label }}" attr.aria-label="{{ value?.labelValue }}" (click)="showTooltip('telematicsStatus', {content: getTelematicsTooltipValue(value?.labelValue),closeIcon: {
                    iconPath: '',
                    altText: ''
                }},listIndex,1)" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div [attr.id]="'collapse' + listIndex" class="accordion-collapse collapse show"
          [attr.aria-labelledby]="'heading' + listIndex" [class.show]="category?.collapsed">
          <div class="accordion-body">
            <div class="row label-main-row d-flex align-items-start m-0">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12"
                *ngIf="category.values[headerList.length]?.icon !== ''">
                <div class="row label-row" tabindex="0">
                  <div class="col-12 label-icon">
                    <img src="{{ category.values[headerList.length]?.icon }}"
                      alt="{{ category.values[headerList.length]?.label }}" class="label-icon" tabindex="0" />
                  </div>
                </div>
              </div>
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12" *ngFor="
                  let value of category?.values
                    | slice
                      : (category.values[headerList.length]?.icon !== ''
                          ? headerList.length + 1
                          : headerList.length)
                      : category.values.length; let mobileIndex = index;
                " [ngClass]="{ card_list_tooltip_mobile: value?.isTooltipPresent === true }">
                <div class="row label-row" [ngClass]="{
 'hiderowlastcol':value?.category === FieldType.hideColumn
 }">
                  <div *ngIf="state.loading" class="gradient-loader"></div>
                  <ng-container *ngIf="!state.loading">
                    <div class="col-lg-2 col-md-2 col-sm-6 col-6 label-value label" *ngIf="value?.label !== ''"
                      attr.aria-label="{{ value?.labelValue || 'undefined' }}" tabindex="0">
                      <div class="header--label" tabindex="0">{{ value?.label }}
                        <span *ngIf="value?.isTooltipPresent===true" class="tooltip--icon">
                          <img id="tooltip-{{value.id}}-{{listIndex}}-{{mobileIndex}}" matTooltipPosition="below"
                            tabindex="0" (click)="showTooltip(value.id, value.tooltip, mobileIndex, listIndex)"
                            attr.aria-label="{{ value.tooltip?.content }}" class="info-image--mobile-view"
                            alt="info icon" src="assets/card_list_tooltip_mobile.svg">
                        </span>
                      </div>
                    </div>
                  </ng-container>
                  <div class="col-lg-10 col-md-10 col-sm-6 col-6 p-l-0 dealershipLabel-value"
                    *ngIf="value.category === FieldType.dealershipInfo"
                    attr.aria-label="{{ value?.labelValue || 'undefined' }}" tabindex="0">
                    <div>
                      {{ value?.labelValue? value?.labelValue : "—" }}
                    </div>
                  </div>
                  <div class="col-lg-10 col-md-10 col-sm-6 col-6 p-l-0 label-value {{value.category}}" [ngClass]="{
                      'asset-wrapper-class':
                        value?.category === FieldType.primaryText,
                      'p-l-4': state.view === View.accordionDeskTop,
                      'text-wrap': state.view === View.tableMobile || state.view === View.accordionMobile

                    }" *ngIf="!state.loading &&
                      (value.category === FieldType.text ||
                      value.category === FieldType.restrictedLink ||
                      value.category === FieldType.primaryText ||
                      value.category === FieldType.invoice 
                      || value.category === FieldType.address) ||
                      (value.category === FieldType.operatorHour && value.labelValue !== subscriptionType.noSubscription)
                    " tabindex="0" attr.aria-label="{{ value.labelValue || 'undefined' }}">
                    <div *ngIf="value.category === FieldType.invoice" class="invoice-status-indicator"
                      attr.aria-label="{{ value?.labelValue || 'undefined' }}" [ngClass]="{
                        'past-due': value.labelValue === InvoiceStatus.pastDue,
                        open: value.labelValue === InvoiceStatus.open,
                        upcoming: value.labelValue === InvoiceStatus.upcoming,
                        paid: value.labelValue === InvoiceStatus.paid,
                        none:
                          value?.labelValue === '' || value?.labelValue === '—'
                      }"></div>
                    <span *ngIf="value.displayType; else regularText" [innerHTML]="useDisplayType(value)"></span>
                    <ng-template #regularText>{{ value?.labelValue }}</ng-template>
                    <img *ngIf="!value?.labelValue && value?.labelValue !== 0" src="assets/dash_icon.svg" alt="" />
                  </div>
                  <div class="col-lg-10 col-md-10 col-sm-6 col-6 p-l-0 label-value" [ngClass]="{
                    'asset-wrapper-class':
                      value?.category === FieldType.primaryText
                  }" *ngIf="
                    value.category === FieldType.primaryText ||
                    value.category === FieldType.orderStatus
                  ">
                    <div *ngIf="value.category === FieldType.orderStatus" class="order-status-indicator" [ngClass]="{
                    'order-in-process': value.labelValue === orderStatus.orderInProcess,
                    'in-production': value.labelValue === orderStatus.inProduction,
                    'shipped': value.labelValue === orderStatus.shipped,
                    'delivered': value.labelValue === orderStatus.delivered,
                    'cancelled': value.labelValue === orderStatus.cancelled,
                    'none': value?.labelValue === '' || value?.labelValue === '—'
                  }"></div>{{ value?.labelValue ? value?.labelValue : "—" }}
                  </div>
                  <div class="col-lg-10 col-md-10 col-sm-6 col-6 p-l-0 label-value"
                    *ngIf="!state.loading && value.category === FieldType.userStatus"
                    attr.aria-label="{{ value?.labelValue || 'undefined' }}" tabindex="0">
                    <div class="user-status-wrapper">
                      <div class="dropdown" *ngIf="!value.isStatusUpdatePending">
                        <mat-form-field tabindex="1">
                          <mat-select disableOptionCentering class="mySelectClass user-status-indicator"
                            panelClass="umPanelClass" yPosition="below" aria-label="select dropdown"
                            [disabled]="value?.cssClass ==='status-disabled' ? true : false"
                            (selectionChange)="updateStatus({id:category?.id,userStatus:value.labelValue})"
                            [ngClass]="{
                   'active':  value.labelValue===  userStatusIcon.active, 'inactive':  value.labelValue ===  userStatusIcon.inactive}" [(ngModel)]="value.labelValue">
                            <mat-option *ngFor="let statusItems of state?.userStatusOption"
                              [value]="statusItems.label | lowercase"
                              [ngClass]="{disabled:statusItems.label.toLowerCase() === 'inactive' && state.activeFlag === category?.id}">
                              <div>
                                <div *ngIf="value.category === FieldType.userStatus" class="user-status-indicator"
                                  [ngClass]="{
                   'active':  statusItems.label.toLowerCase() ===  userStatusIcon.active, 'inactive':   statusItems.label.toLowerCase() ===  userStatusIcon.inactive }">
                                </div>
                                {{ statusItems.label }}
                              </div>
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <ng-container *ngIf="value.isStatusUpdatePending">
                        <div class="user-status-update-pending">
                          <div class="user-status-update-pending-text">{{ value.statusUpdatePendingMessage }}</div>
                        </div>
                      </ng-container>
                      <span *ngIf="value.isError && !value.isStatusUpdatePending" class="status-error">
                        <img id="api-error-tooltip-{{value.id}}-{{listIndex}}-{{mobileIndex}}"
                          matTooltipPosition="below" tabindex="0"
                          (click)="showTooltip(value.id, value.tooltip, mobileIndex, listIndex)"
                          attr.aria-label="{{ value.tooltip?.content }}" class="info-image--mobile-view"
                          [src]="value.errorIcon?.iconPath" [alt]="value.errorIcon?.altText">
                      </span>
                    </div>
                  </div>
                  <div class="col-lg-10 col-md-10 col-sm-6 col-6 p-l-0 label-value" [ngClass]="{
                    'asset-wrapper-class':
                      value?.category === FieldType.primaryText
                  }" *ngIf="
                    value.category === FieldType.primaryText ||
                    value.category === FieldType.crStatus
                  ">
                    <div *ngIf="value.category === FieldType.crStatus" class="cr-status-indicator" [ngClass]="{
                    'awaitingApproval': value.labelValue === crStatus.awaitingApproval,
                    'approved': value.labelValue === crStatus.approved,
                    'cancelled': value.labelValue === crStatus.cancelled,
                    'none': value?.labelValue === '' || value?.labelValue === '—'
                  }"></div>{{ value?.labelValue ? value?.labelValue : "—" }}
                  </div>
                  
                  <div class="col-lg-10 col-md-10 col-sm-6 col-6 p-l-0 label-value" [ngClass]="{
                    'asset-wrapper-class':
                      value?.category === FieldType.primaryText
                  }" *ngIf="
                    value.category === FieldType.primaryText ||
                    value.category === FieldType.myQuoteStatus
                  ">
                    <div *ngIf="state.loading" class="gradient-loader"></div>
                    <div *ngIf="!state.loading">
                      <div *ngIf="value.category === FieldType.myQuoteStatus" class="myQuote-status-indicator"
                        [ngClass]="{
                    'quoteinProcess': value.labelValue === myQuoteStatus.quoteinProcess,
                    'quoteAccepted': value.labelValue === myQuoteStatus.quoteAccepted,
                    'ordered': value.labelValue === myQuoteStatus.ordered,
                    'expired': value.labelValue === myQuoteStatus.expired,
                    'readyForReview': value.labelValue === myQuoteStatus.readyForReview,
                    'none': value?.labelValue === '' || value?.labelValue === '—'
                  }"></div>{{ value?.labelValue !== "" ? value?.labelValue : "—" }}
                    </div>
                  </div>
                  <div class="col-lg-10 col-md-10 col-sm-6 col-6 p-l-0 label-value value-link" *ngIf="!state.loading &&
                      value.category === FieldType.link &&
                      value.labelValue !== ''
                    "
                    (click)="value.label === invoiceCheck.invoice ? downloadInvoicePDF(value.labelValue): linkToRedirectionEquipment(value.labelValue, value.label, category?.id,category?.customerId,category?.orderId,category?.locationId)"
                    attr.aria-label="{{ value?.labelValue || 'undefined' }}" tabindex="0">
                    {{ value?.labelValue? value?.labelValue : "—" }}
                    <span><img *ngIf="value.label === invoiceCheck.invoice" class="pdfIcon"
                        src="/assets/myservice_pdf.svg" tabindex="0" aria-label="Download pdf Icon"
                        alt="Download pdf Icon" (click)="downloadInvoicePDF(value.labelValue)"/></span>
                  </div>

                  <div class="col-lg-10 col-md-10 col-sm-6 col-6 p-l-0 label-value"
                    *ngIf="value.category === FieldType.currency"
                    attr.aria-label="{{ value?.labelValue || 'undefined' }}" tabindex="0">
                    {{
                    (value?.labelValue === "0.00") ? "$0" :
                    value?.labelValue !== "—" && value?.labelValue !== ""
                    ? (convertStringToNumber(value?.labelValue)
                    | currency: value?.currency:"symbol":"1.2-2")
                    : "—"
                    }}
                  </div>
                  <div class="col-lg-10 col-md-10 col-sm-6 col-6 p-l-0 label-value"
                    *ngIf="!state.loading && value.category === FieldType.date" attr.aria-label="{{ value?.labelValue ? (convertStringToNumber(value?.labelValue)
                      | date: 'MM/dd/YYYY') || 'undefined' : 'undefined' }}" tabindex="0">
                    {{
                    value?.labelValue !== "—" && value?.labelValue !== "" && value.labelValue !== null
                    ? (convertStringToNumber(value?.labelValue)
                    | date: "MM/dd/YYYY") : "—"
                    }}
                  </div>
                  <div tabindex="0" class="col-lg-10 col-md-10 col-sm-6 col-6 p-l-0 label-value"
                    *ngIf="value.category === FieldType.image && isTelematicsStatus(value?.labelValue)">
                    <img *ngIf="isTelematicsResponse.connected" class="connected-icon" src="assets/connected.svg"
                      alt="connected" />
                    <img *ngIf="isTelematicsResponse.error" matTooltipPosition="below"
                      matTooltip={{state?.errorIcon?.altText}} #tooltip="matTooltip" matTooltipClass="errorTooltip"
                      (click)="tooltip.toggle()" src="assets/information.svg" alt="Unable to retrieve information" />
                  </div>
                  <div class="col-lg-10 col-md-10 col-sm-6 col-6 p-l-0 label-value"
                    *ngIf="value.category === FieldType.dateString"
                    attr.aria-label="{{ value?.labelValue !== '—' && value?.labelValue !== '' && value?.labelValue !== null ? (convertStringToDate(value?.labelValue) | date: 'MM/dd/yyyy') || 'undefined' : 'undefined' }}"
                    tabindex="0">
                    {{value?.labelValue !== "—" && value?.labelValue !== "" && value?.labelValue !== null ?
                    (convertStringToDate(value?.labelValue) | date: "MM/dd/yyyy") : "—"}}
                  </div>
                  <div class="col-lg-10 col-md-10 col-sm-6 col-6 p-l-0 label-value"
                    *ngIf="value.category === FieldType.operatorHour && value?.labelValue === subscriptionType.noSubscription"
                    tabindex="0">
                    <img src="assets/Lock.svg" alt=""
                    [matTooltipPosition]="position.value!" matTooltip="{{ value.tooltip?.content }}"
                    matTooltipClass="card-list-tooltip"
                    #tooltip="matTooltip" (click)="tooltip.toggle()">
                  </div>
                  <div tabindex="0" attr.aria-label="{{ value?.labelValue}}" class="col-lg-10 col-md-10 col-sm-6 col-6 p-l-0 label-value subscriptionTerm" *ngIf="value.category === FieldType.primarySubLocation || value.category === FieldType.equipmentAddress">
                    <div class="subscriptionTerm-heading">{{ category.locationLabel }}</div>
                    <div class="subscriptionTerm-subHeading">{{value?.labelValue? value.labelValue : '-'}}</div>
                  </div>
                  <div tabindex="0" attr.aria-label="{{ value?.labelValue}}" class="col-lg-10 col-md-10 col-sm-6 col-6 p-l-0 label-value subscriptionTerm" *ngIf="value.category === FieldType.subscriptionTerm">
                    <div class="subscriptionTerm-heading">{{ (value?.labelValue !== "" && value?.labelValue !== null) ? value?.labelValue : "—" }}</div>
                    <div *ngIf="value.subscriptionTerm" class="subscriptionTerm-subHeading"[ngClass]="value.subscriptionTerm.fontClass">{{value.subscriptionTerm.date? value.subscriptionTerm.date : ''}}</div>
                  </div>
                  
          <div  tabindex="0" attr.aria-label="{{ value?.labelValue}}" *ngIf="value.category === FieldType.subscription" class="col-lg-10 col-md-10 col-sm-6 col-6 p-l-0 label-value">
              <div class="subscription-type-indicator" [ngClass]="getSubscriptionStatusClass(value.labelValue)"></div>{{ value?.labelValue !== "" ? value?.labelValue : "—" }}

          </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div role="rowgroup" aria-label="Card list content wrapper" *ngIf="state.view === View.tableDesktop">
    <div role="row" tabindex="0" *ngIf="state.error && dataList.length === 0 && !state.loading" class="no-results">
      <img src="{{ state.error?.icon }}" alt="noresults" />
      <div class="no-results-text">{{ state.error?.message }}</div>
      <div class="no-results-subtext">{{ state.error?.messageSubText }}</div>
    </div>
    <div role="rowgroup" *ngIf="dataList && dataList.length > 0" aria-label="Card list content items">
      <div role="row" tabindex="0" attr.aria-label="Card list item #{{ listIndex + 1 }}"
        class="content-section table-row"
        *ngFor="let category of dataList| paginate: { itemsPerPage: 50, currentPage: pageNumber, totalItems: pager.totalItems  }; let listIndex = index">

        <div *ngIf="!state.loading && isCheckBoxRequired" class="mobileView checkbox" tabindex="0" attr.aria-label="header for checkbox column">
          <mat-checkbox [checked]="category.checked"
          (change)="handleItemCheckBoxChange(category, $event.checked, listIndex)" [disabled]="category.changeRequest?.display === 'disable'" matTooltipPosition="right"
          [matTooltip]="category.changeRequest?.tooltip || ''"
          attr.aria-label="{{ category.changeRequest?.tooltip }}" matTooltipClass="bulkTooltip telematicsStatusTooltip">
          </mat-checkbox>
        </div>

        <div role="cell" tabindex="0" class="label-col col " attr.aria-label="Card list item #{{ listIndex + 1 }}, value: {{
            value?.labelValue
          }}" *ngFor="let value of category?.values; let colIndex = index" [ngClass]="{
            'hiderowlastcol':value?.category === FieldType.hideColumn,
            'header-icon':
              value?.category === FieldType.action ||
              value?.category === FieldType.indicator,
              'telematics-icon': value?.category === FieldType.image
          }">
          <div *ngIf="state.loading" class="gradient-loader"></div>

          <div *ngIf="!state.loading">
            <div tabindex="0" attr.aria-label="{{ value?.labelValue || 'undefined' }}" class="{{value.category}}"
              [ngClass]="{
              'asset-wrapper-class': value?.category === FieldType.primaryText,
              'show-ellipsis':
                (value?.category === FieldType.text || value?.category === FieldType.restrictedLink) &&
                value?.category !== FieldType.primaryText
            }" *ngIf="
              value.category === FieldType.text  ||
              value.category === FieldType.restrictedLink ||
              value.category === FieldType.primaryText ||
              (value.category === FieldType.operatorHour && value.labelValue !== subscriptionType.noSubscription)
            ">
              <img *ngIf="value?.icon" [src]="value.icon" [ngClass]="value.cssClass">
              <span *ngIf="value.displayType; else regularText" [innerHTML]="useDisplayType(value)"></span>
              <ng-template #regularText>{{ value?.labelValue }}</ng-template>
              <img *ngIf="!value?.labelValue && value?.labelValue !== 0" src="assets/dash_icon.svg" alt="" />
            </div>

          </div>
          <div *ngIf="state.loading && value.category === FieldType.image && isTelematicsStatus(value?.labelValue)"
            class="gradient-loader"></div>
          <div *ngIf="!state.loading">
            <div tabindex="0" class="{{value.category}}"
              *ngIf="value.category === FieldType.image && isTelematicsStatus(value?.labelValue)">
              <img *ngIf="isTelematicsResponse.connected" class="connected-icon" src="assets/connected.svg"
                alt="Connected" />
              <img *ngIf="isTelematicsResponse.error" matTooltipPosition="right"
                matTooltip={{state?.errorIcon?.altText}} alt="Unable to retrieve information" #tooltip="matTooltip"
                matTooltipClass="errorTooltip" alt="Unable to retrieve information" src="assets/information.svg" />
            </div>
          </div>
          <div *ngIf="value.category === FieldType.link">
            <div *ngIf="state.loading" class="gradient-loader"></div>
            <div *ngIf="!state.loading">
              <button class="label-link vin-wrapper-class" [ngClass]="{
                'blank-link':
                  value?.labelValue === '—' || value?.labelValue === '' || value?.labelValue === null
              }" attr.aria-label="{{ value?.labelValue || 'undefined' }}" tabindex="0"
                (click)="linkToRedirectionEquipment(value.labelValue,value.label, category?.id,category?.customerId, category?.orderId, category?.locationId)">
                {{ value?.labelValue? value?.labelValue : "—" }}</button>
              <div class="servicecampaigntext" [ngClass]="{
                'active': value.serviceCampaign === true
              }">Service Campaign</div>
            </div>
          </div>

          <div *ngIf="value.category === FieldType.date" attr.aria-label="{{ value?.labelValue ? (convertStringToNumber(value?.labelValue)
            | date: 'MM/dd/YYYY') || 'undefined' : 'undefined' }}" tabindex="0">
            <div *ngIf="state.loading" class="gradient-loader"></div>
            <div *ngIf="!state.loading">
              {{ value?.labelValue !== "—" && value?.labelValue !== "" && value.labelValue !== null
              ? (convertStringToNumber(value?.labelValue) | date: "MM/dd/YYYY") : "—"
              }}
            </div>
          </div>
          <div *ngIf="value.category === FieldType.operatorHour && value.labelValue === subscriptionType.noSubscription">
            <div *ngIf="state.loading" class="gradient-loader"></div>
            <div *ngIf="!state.loading">
              <img src="assets/Lock.svg" matTooltipPosition="right"
              matTooltip="{{ value.tooltip?.content }}" class="" #tooltiplock="matTooltip" (window:scroll)="tooltiplock.hide()"
              attr.aria-label="{{ value.tooltip?.content }}"
              matTooltipClass="card-list-tooltip"
              matTooltipPositionAtOrigin="true">
            </div>
          </div>
          <div class="dropdown-selector" *ngIf="value.category === FieldType.userStatus"
            attr.aria-label="{{ value?.labelValue || 'undefined' }}">
            <div *ngIf="state.loading" class="gradient-loader"></div>
            <div *ngIf="!state.loading">
              <div class="user-status-wrapper">
                <div class="dropdown" *ngIf="!value.isStatusUpdatePending">
                  <mat-form-field>
                    <mat-select disableOptionCentering class="mySelectClass user-status-indicator"
                      panelClass="umPanelClass" yPosition="below" aria-label="select dropdown"
                      [disabled]="value?.cssClass ==='status-disabled' ? true : false"
                      (selectionChange)="updateStatus({id:category?.id,userStatus:value.labelValue})"
                      [ngClass]="{
                   'active':  value.labelValue ===  userStatusIcon.active, 'inactive':  value.labelValue ===  userStatusIcon.inactive}" [(ngModel)]="value.labelValue">
                      <mat-option *ngFor="let statusItems of state?.userStatusOption"
                        [value]="statusItems.label | lowercase"
                        [ngClass]="{disabled:statusItems.label.toLowerCase() === 'inactive' && state.activeFlag === category?.id}"
                        #statusItems>
                        <div>
                          <div *ngIf="value.category === FieldType.userStatus" class="user-status-indicator"
                            [ngClass]="{
                   'active':  statusItems.label.toLowerCase() ===  userStatusIcon.active, 'inactive':   statusItems.label.toLowerCase() ===  userStatusIcon.inactive }"></div>
                          {{ statusItems.label }}
                        </div>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <ng-container *ngIf="value.isStatusUpdatePending">
                  <div class="user-status-update-pending">
                    <div class="user-status-update-pending-text">{{ value.statusUpdatePendingMessage }}</div>
                  </div>
                </ng-container>
                <span *ngIf="value.isError && !value.isStatusUpdatePending" class="status-error">
                  <img [src]="value.errorIcon?.iconPath" [alt]="value.errorIcon?.altText" matTooltipPosition="below"
                    matTooltip={{value.tooltip?.content}} class="info-image--desktop-view" #tooltiperror="matTooltip" (window:scroll)="tooltiperror.hide()"
                    attr.aria-label="{{ value.tooltip?.content }}"
                    matTooltipClass="{{value.tooltipClass? value.tooltipClass : 'card-list-error-tooltip'}}"
                    matTooltipPositionAtOrigin="true">
                </span>
              </div>
            </div>
          </div>

          <div tabindex="0" attr.aria-label="{{ value?.labelValue }}" *ngIf="value?.category === FieldType.action">
            <div *ngIf="state.loading" class="gradient-loader"></div>
            <div *ngIf="!state.loading && !this.isCheckBoxRequired">
              <button tabindex="0" mat-icon-button [matMenuTriggerFor]="menu" class="table-menu"
                aria-label="Example icon-button with a menu">
                <img src="{{ value?.icon }}" alt="{{value?.label}}" />
              </button>
              <mat-menu class="tableOptions" #menu="matMenu" [overlapTrigger]="false" xPosition="before" yPosition="below">
                <button mat-menu-item
                  [disabled]="actionItems?.actionLabel === actionLabelConstants.editLocationLabel && !category.isLabelEditable || (actionItems?.actionLabel === actionLabelConstants.cancelRenewal && !category.autoRenew)"
                  (click)="onActionClick(category, actionItems)" *ngFor="let actionItems of state?.actionOpsList">
                  <span>{{ actionItems?.actionLabel }}</span>
                </button>
              </mat-menu>
            </div>
          </div>
          <div *ngIf="state.loading" class="gradient-loader"></div>
          <div *ngIf="!state.loading">
          <div  tabindex="0" attr.aria-label="{{ value?.labelValue}}" class="subscriptionTerm" *ngIf="value.category === FieldType.subscriptionTerm">
            <div class="subscriptionTerm-heading">{{ (value?.labelValue !== "" && value?.labelValue !== null) ? value?.labelValue : "—" }}</div>
            <div *ngIf="value.subscriptionTerm" class="subscriptionTerm-subHeading"[ngClass]="value.subscriptionTerm.fontClass">{{value.subscriptionTerm.date? value.subscriptionTerm.date : ''}}</div>
          </div>
          </div>
          <div *ngIf="state.loading" class="gradient-loader"></div>
            <div *ngIf="!state.loading">
          <div tabindex="0" attr.aria-label="{{ value?.labelValue}}" class="subscriptionTerm" *ngIf="value.category === FieldType.primarySubLocation || value.category === FieldType.equipmentAddress">
            <div class="subscriptionTerm-heading">{{value.category === FieldType.primarySubLocation? category.locationLabel: value.category === FieldType.equipmentAddress ? category.equipmentAddressLabel: ''}}</div>
            <div class="subscriptionTerm-subHeading">{{value?.labelValue? value.labelValue : '-'}}</div>
          </div>
          </div>
          <div attr.aria-label="{{ value?.labelValue || 'undefined' }}" tabindex="0" [ngClass]="{
            'asset-wrapper-class':
              value?.category === FieldType.orderStatus
          }" *ngIf="
            value.category === FieldType.orderStatus
          ">
            <div *ngIf="state.loading" class="gradient-loader"></div>
            <div *ngIf="!state.loading">
              <div *ngIf="value.category === FieldType.orderStatus" class="order-status-indicator" [ngClass]="getOrderStatusClass(value.labelValue)"></div>{{ value?.labelValue !== "" ? value?.labelValue : "—" }}
            </div>
          </div>
          <div attr.aria-label="{{ value?.labelValue || 'undefined' }}" tabindex="0" [ngClass]="{
            'asset-wrapper-class':
              value?.category === FieldType.subscription
          }" *ngIf="
            value.category === FieldType.subscription
          ">
            <div *ngIf="state.loading" class="gradient-loader"></div>
            <div *ngIf="!state.loading">
              <div *ngIf="value.category === FieldType.subscription" class="subscription-type-indicator" [ngClass]="getSubscriptionStatusClass(value.labelValue)"></div>{{ value?.labelValue !== "" ? value?.labelValue : "—" }}
            </div>
          </div>
          <div tabindex="0" attr.aria-label="{{ value?.labelValue || 'undefined' }}"
            *ngIf="value?.category === FieldType.indicator && value.label !== FieldType.telematicsStatus">
            <div *ngIf="state.loading" class="gradient-loader"></div>
            <div *ngIf="!state.loading" tabindex="0" [hidden]="!value?.labelValue">
              <img src="{{ value?.icon }}" [matTooltipPosition]="position.value!"
                matTooltip="{{ state?.tooltipMessage }}" alt="{{ value?.label }}"
                attr.aria-label="{{ state?.tooltipMessage }}" matTooltipClass="serviceTooltip" />
            </div>
          </div>
          <div tabindex="0" attr.aria-label="{{ value?.labelValue || 'undefined' }}"
            *ngIf="value?.category === FieldType.indicator && value?.label === FieldType.telematicsStatus">
            <div *ngIf="state.loading" class="gradient-loader"></div>
            <div *ngIf="!state.loading && (value?.labelValue === 'connected' || value?.labelValue === 'Active') " tabindex="0">
              <img src="{{ value?.icon }}" [matTooltipPosition]="position.value!"
                [matTooltip]="getTelematicsTooltipValue(value?.labelValue) " alt="{{ value?.label }}"
                attr.aria-label="{{ value?.labelValue }}" matTooltipClass="telematicsStatusTooltip" />
            </div>
          </div>

          <div *ngIf="value.category === FieldType.dateString"
            attr.aria-label="{{ value?.labelValue !== '—' && value?.labelValue !== '' && value?.labelValue !== null ? (convertStringToDate(value?.labelValue) | date: 'MM/dd/yyyy') || 'undefined' : 'undefined' }}"
            tabindex="0">
            <div *ngIf="state.loading" class="gradient-loader"></div>
            <div *ngIf="!state.loading">
              {{value?.labelValue !== "—" && value?.labelValue !== "" && value?.labelValue !== null ?
              (convertStringToDate(value?.labelValue) | date: "MM/dd/yyyy") : "—"}}
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div *ngIf="dataList.length !== 0 && state.loading" class="pagination-loader">
    <div class="gradient-loader"></div>
    <div class="gradient-loader"></div>
  </div>
  <div class="pagination-container" *ngIf="dataList.length !== 0 && !state.loading && !state.hidePagination">
    <div class="show-data" [ngClass]="{'singlepage': !(pager.totalPages>1) }" tabindex="0">
      <span class="pagination-showing">Showing {{ pager.startIndex + 1 | number }}-{{ pager.endIndex + 1 | number }} of
        {{ state?.pageInfo?.totalCount | number }}</span>

    </div>
    <pagination-controls *ngIf="pager.totalPages>1" role="currentpage" (pageChange)="setPage($event);pageClick()"
      previousLabel="" aria-controls="setPage($event)" nextLabel="" class="pagination-bar" [maxSize]="7"
      nextLabel="next" [autoHide]="true" screenReaderPaginationLabel="Pagination Navigation" previousLabel="previous"
      screenReaderCurrentLabel="You are on the current Page"></pagination-controls>
  </div>
</div>